import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/features';
import HintPopup from '../components/HintPopup/HintPopup';

export default function SessionExplanationHint() {
  const { t } = useTranslation();
  const title = t('Dashboard.SessionExplainer.Title');
  const buttonLabel = t('Dashboard.SessionExplainer.Close');
  const contentHtml = renderStringToReact(
    t('Dashboard.SessionExplainer.ContentHtml'),
    ETagType.div,
    'session-explanation-content'
  );
  return (
    <HintPopup title={title} iconSize={24} okButtonLabel={buttonLabel}>
      {contentHtml}
    </HintPopup>
  );
}
